import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import DatatableComponent from "../../helpers/DatatableComponent";
import React, { useEffect, useState } from "react";
import FormDialog from "../../helpers/FormDialog";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";
import OpenDocument from "../../helpers/openDocument";
import { getDuration, getFileMime } from "../../store/helpers/common_functions";
import BasicMenu from "../../helpers/menu";
import DeleteDialog from "../../helpers/DeleteDialog";
import BootstrapDialogTitle from "../../helpers/BootstrapDialogTitle";
import { a11yProps } from "components/Meetings/Meeting";
import { TabPanel } from "components/Meetings/Meeting";
import { Link } from "react-router-dom";
import CompletionCertificate from "components/Document/CompletionCertificate";
import {
  Delete,
  Visibility,
} from "@mui/icons-material";

function Document({ SetSelectedMenu, ListAllProjects, projects,systemSettings }) {
  const mainBackground = systemSettings?.mainBackground;

  const [count, setCount] = useState(0);
  const [open, setOpen] = React.useState(0);
  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [fileView, setFileView] = useState(null);
  const [projectId, setProjectId] = React.useState();
  const [project, setProject] = React.useState({});
  const [tabValue, setTabValue] = useState(0);
  const [description, setDescription] = useState();
  const [openView, setOpenView] = useState(false);
  const [managed, setManaged] = useState(true);
  const [fileName, setFileName] = useState("");
  const [certificateTab, setCertificateTab] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const projectList = projects?.filter((item) => item?.status === "completed");
  useEffect(() => {
    if (projectId) {
      const selectedProject = projectList?.find(
        (item) => item?.id === projectId
      );
      const pm = selectedProject?.assignee?.find(
        (item) => item.role === "project-manager"
      );
      setProject({ ...selectedProject, pm: pm?.Resource?.names });
    }
  }, [projectId]);

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };
  useEffect(() => {
    SetSelectedMenu({
      menu: "document",
      title: "Document Hub",
    });
    ListAllProjects();
  }, []);

  const types =
    tabValue === 1
      ? [
          {
            label: "Procedure Manuals",
            value: "company",
          },
          {
            label: "PMO Manuals",
            value: "project",
          },

          {
            label: "Developers(best practices)",
            value: "developers",
          },
          {
            label: "DevOps(best practices)",
            value: "devops",
          },
          {
            label: "Technical Manuals",
            value: "technical",
          },
          {
            label: "R&D Manuals",
            value: "r&d",
          },
        ]
      : [
          {
            label: "Completion certificate",
            value: "certificate",
          },
        ];

  const columns = [
    {
      name: "title",
      data: "title",
      label: "Title",
    },
    {
      name: "description",
      data: "description",
      label: "Description",
    },
    {
      name: "type",
      data: "type",
      label: "Type",
      options: {
        customBodyRender: (v) => types.find((item) => item.value === v)?.label,
      },
    },

    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const obj = list[rowIndex];

          return (
            <BasicMenu
              onDelete={() => {
                setDeleteOpen(true);
                setId(obj?.id);
              }}
              onEdit={() => {
                setOpen(2);
                setId(obj?.id);
                setValue0("title", obj.title);
                setValue0("description", obj.description);
                setValue0("type", obj.type);
              }}
              onDetails={() => {
                setFileView(obj?.attachment);
                setOpenView(true);
                setDescription(obj?.description);
              }}
            />
          );
        },
      },
    },
  ];

  const unmanagedColumns = [
    {
      name: "unmanagedProject.name",
      data: "unmanagedProject.name",
      label: "Project",
    },
    {
      name: "unmanagedProject.client",
      data: "unmanagedProject.client",
      label: "Project Client",
    },
    {
      name: "description",
      data: "description",
      label: "Description",
    },

    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const obj = list[rowIndex];

          return (
            <div className="flex gap-4">
              <Tooltip title="Details">
                <Visibility
                  sx={{
                    cursor: "pointer",
                    color: mainBackground,
                  }}
                  role="button"
                  onClick={() => {
                    setFileView(obj?.attachment);
                    setOpenView(true);
                    setDescription(obj?.description);
                  }}
                />
              </Tooltip>

              <Tooltip title="Delete">
                <Delete
                  role="button"
                  color="error"
                  onClick={() => {
                    setDeleteOpen(true);
                    setId(obj?.id);
                  }}
                />
              </Tooltip>
            </div>
          );
        },
      },
    },
  ];

  const columnsCert = [
    {
      name: "Project.name",
      data: "Project.name",
      label: "Project",
    },
    {
      name: "Project.name",
      data: "Project.name",
      label: "Project Manager",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const pm = list[rowIndex]?.Project?.assignee?.find(
            (item) => item.role === "supervisor"
          );
          return pm?.Resource?.names;
        },
      },
    },
    {
      name: "Project.client",
      data: "Project.client",
      label: "Project Client",
    },
    {
      name: "duration",
      label: "Duration",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) =>
          getDuration(
            list[rowIndex]?.Project?.endDate,
            list[rowIndex]?.Project?.startDate
          ),
      },
    },

    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const obj = list[rowIndex];

          return (
            <div className="flex gap-4">
              <Tooltip title="Details">
                <Visibility
                  sx={{
                    cursor: "pointer",
                    color: mainBackground,
                  }}
                  role="button"
                  onClick={() => {
                    setFileView(obj?.attachment);
                    setOpenView(true);
                    setDescription(obj?.description);
                  }}
                />
              </Tooltip>

              <Tooltip title="Delete">
                <Delete
                  role="button"
                  color="error"
                  onClick={() => {
                    setDeleteOpen(true);
                    setId(obj?.id);
                  }}
                />
              </Tooltip>
            </div>
          );
        },
      },
    },
  ];
  return (
    <div className="w-full mb-12 px-4">
      <div className="">
        <div className="flex justify-between items-center">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item pageTitle">
                <Link
                  to="/admin/document"
                  className="text-white text-decoration-none"
                >
                  {tabValue === 1 ? "Certificates" : "Document"}
                </Link>
              </li>
            </ol>
          </nav>
        </div>
        <Card className={"overflow-auto mt-3"} variant={"outlined"}>
          <div className={"card-body mt-0 pt-0"}>
            <div className="row group-btn">
              <div className="col-md-7"></div>
            </div>
            <Dialog
              maxWidth={"md"}
              fullWidth={true}
              open={openView}
              onClose={() => setOpenView(false)}
            >
              <BootstrapDialogTitle onClose={() => setOpenView(false)}>
                Document Details
              </BootstrapDialogTitle>
              <DialogContent>
                Description: {description}
                {fileView !== null && (
                  <OpenDocument
                    downloadable={true}
                    document={fileView}
                    name={"supportDocument"}
                    specialName={fileView}
                    type={"permission-doc"}
                    mimeType={getFileMime(fileView)}
                  />
                )}
              </DialogContent>
            </Dialog>
            <DeleteDialog
              url={`/api/document/delete/${id}`}
              open={deleteOpen}
              setOpen={setDeleteOpen}
              onSuccess={() => {
                setCount((v) => v + 1);
                if (certificateTab === 0) {
                  setCertificateTab(1);
                  setCertificateTab(0);
                } else {
                  setCertificateTab(0);
                  setCertificateTab(1);
                }
              }}
              title={"Delete Document"}
            />
            <FormDialog
              onSuccess={() => {
                setCount((v) => v + 1);
                if (certificateTab === 0) {
                  setCertificateTab(1);
                  setCertificateTab(0);
                } else {
                  setCertificateTab(0);
                  setCertificateTab(1);
                }
              }}
              url={
                open === 1
                  ? "/api/document/create"
                  : `/api/document/update/${id}`
              }
              fields={[
                {
                  name: "type",
                  label: "Type",
                  type: "select",
                  value: value["type"],
                  values: types,
                  required: true,
                  setValue: (val) => setValue0("type", val),
                },
                {
                  name: "title",
                  label: "Title",
                  type: "text",
                  value: value["title"],
                  required: true,
                  setValue: (val) => setValue0("title", val),
                  hidden: value["type"] === "certificate",
                },
                {
                  name: "ProjectType",
                  label: "Choose Project Category ?",
                  type: "radio",
                  col: 12,
                  checkCol: 2,
                  value: managed ? "managed" : "not managed",
                  values: [
                    { label: "Managed", value: "managed" },
                    { label: "Not Managed", value: "not managed" },
                  ],
                  required: true,
                  hidden: value["type"] !== "certificate",
                  setValue: (val) => setManaged(val === "managed"),
                },
                {
                  name: "projectId",
                  label: "Project",
                  type: "select",
                  value: project?.id,
                  values: projectList?.map((item) => ({
                    label: item.name,
                    value: item.id,
                  })),
                  required: true,
                  hidden: value["type"] !== "certificate" || !managed,
                  setValue: setProjectId,
                },
                {
                  name: "unmanaged_projectId",
                  label: "Previous Project",
                  type: "text",
                  // value: project?.name,

                  // disabled: true,
                  value: value["unmanaged_projectId"],
                  setValue: (val) => setValue0("unmanaged_projectId", val),
                  hidden: value["type"] !== "certificate" || managed,
                },
                {
                  name: "name",
                  label: "Project Manager",
                  type: "text",
                  value: project?.pm,
                  disabled: true,
                  hidden: value["type"] !== "certificate" || !managed,
                },
                {
                  name: "client",
                  label: "Client",
                  type: "text",
                  value: value["client"] || project?.client,
                  disabled: managed,
                  setValue: (val) => setValue0("client", val),
                  hidden: value["type"] !== "certificate",
                },
                {
                  name: "attachment",
                  label: "Attachment",
                  type: "file-drag",
                  multiple: true,
                  accept: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.zip",
                  value: value["termsOfReference"],
                  // required: open === 1,
                  setValue: (val) => setValue0("termsOfReference", val),
                },
                {
                  name: "description",
                  label: "Description",
                  type: "textarea",
                  value: value["description"],
                  required: false,
                  setValue: (val) => setValue0("description", val),
                  hidden: value["type"] === "certificate" && managed,
                },
              ]}
              open={open}
              setOpen={setOpen}
              title={open === 1 ? "Add New Document" : "Update Document"}
            />

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={tabValue}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label={"Completion Certificates"}
                  iconPosition={"end"}
                  {...a11yProps(0)}
                />
                <Tab
                  label="Other Manuals"
                  {...a11yProps(1)}
                  iconPosition={"end"}
                />
              </Tabs>
            </Box>
            <TabPanel value={tabValue} index={0}>
              <Tabs
                className="mt-5"
                value={certificateTab}
                onChange={(e, v) => setCertificateTab(v)}
                aria-label="basic tabs example"
              >
                <Tab
                  label={"Current Projects"}
                  iconPosition={"end"}
                  {...a11yProps(0)}
                />

                <Tab
                  label="Previous Projects"
                  {...a11yProps(1)}
                  iconPosition={"end"}
                />
              </Tabs>
              <TabPanel value={certificateTab} index={0}>
                <CompletionCertificate
                  setOpen={setOpen}
                  count={count}
                  columnsCert={columnsCert}
                  setList={setList}
                />
              </TabPanel>

              <TabPanel value={certificateTab} index={1}>
                <DatatableComponent
                  onRowClick={(data, { rowIndex }) => {}}
                  onAddNew={() => setOpen(1)}
                  processData={(data) => {
                    setList(data.data);
                    return data;
                  }}
                  elevation={1}
                  columns={unmanagedColumns}
                  url={`/api/document/list?projectType=unmanaged`}
                  title={``}
                />
              </TabPanel>
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
              <DatatableComponent
                onRowClick={(data, { rowIndex }) => {}}
                onAddNew={() => setOpen(1)}
                processData={(data) => {
                  setList(data.data);
                  return data;
                }}
                elevation={1}
                columns={columns}
                url={`/api/document/list?count=${count}`}
                title={``}
              />
            </TabPanel>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Document);
